export default {
  "bank.ux.revokePayeeWarning": "Отозвать подтверждение получателя",
  "bank.ux.warningAccepted": "Предупреждение принято OWNER Finance; банк не подтвердил получателя.",
  "bank.ux.acceptPayeeWarning": "Понимаю, что банк не подтвердил получателя, и разрешаю создать черновик с этими реквизитами.",
  "bank.ux.checkNotPossible": "Банк не смог проверить получателя.",
  "bank.ux.checkPending": "Банк не вернул результат вовремя. Это не означает, что IBAN указан неверно.",
  "bank.ux.creatingDrafts": "Создаём черновики в банке…",
  "bank.ux.checkInvalidIban": "IBAN не указан или некорректен. Введите правильный IBAN получателя.",
  "bank.ux.checkPermission": "Для этого действия недостаточно прав или банковских полномочий. Обратитесь к администратору организации.",

  "bank.ux.checkIssues": "Проверка получателей требует решения",
  "bank.ux.checkIssuesHelp": "Черновики в банке ещё не созданы. Рассмотрите предупреждения. OWNER Finance может принять результат неуспешной проверки и продолжить.",
  "bank.ux.checkMismatch": "Банк не подтвердил соответствие счёта получателю. Проверьте IBAN.",
  "bank.ux.checkName": "Подтвердите имя получателя, предложенное банком.",
  "bank.ux.checkUnavailable": "Проверить получателя не удалось. Повторите попытку или проверьте реквизиты.",
  "bank.ux.acceptBankName": "Подтвердить имя получателя, указанное банком: {name}",
  "bank.ux.correctRecipientIban": "Исправленный IBAN получателя (пусто — оставить прежний)",
  "bank.ux.checkingRecipients": "Проверяем получателей…",
  "bank.ux.recheckAndContinue": "Проверить повторно и продолжить",
  "bank.ux.checkAndContinue": "Проверить получателей и продолжить",

  "payables.dueBefore": "Оплатить до",
  "payables.currency": "Валюта",
  "payables.allCurrencies": "Все валюты",
  "payables.selectFiltered": "Выбрать по фильтру",
  "payables.clearSelection": "Снять выбор",
  "payables.selectSupplier": "Выбрать поставщика",
  "payables.selectionLimit": "Можно выбрать до 100 накладных. Сузьте фильтр.",
  "payables.chooseCurrency": "Выберите одну валюту.",

  "bank.ux.timeBudgetPaused": 'Создано {created} черновиков. Ещё не созданы {remaining}. Остановились заранее, чтобы дождаться ответов банка. Готовые черновики сохранены.',
  "bank.ux.timeBudgetNotCreated": 'Этот черновик ещё не создавался в банке.',
  "bank.ux.continueRemaining": 'Продолжить оставшиеся',
  "bank.ux.enableDescription": "Подключите BluOr, чтобы готовить черновики платежей поставщикам. Платежи подтверждаются в банке.",
  "bank.ux.bankSandbox": "Это подключение будет использовать банковскую песочницу BluOr.",
  "bank.ux.enableBank": "Настроить BluOr",
  "bank.ux.platformSetupRequired": "Администратор платформы должен сначала включить банковскую интеграцию.",
  'bank.ux.setupUnavailable': 'Банковские подключения для этой организации ещё не включены. Администратор должен включить настройку банка.',
  "bank.ux.ownerOrganization": "Организация-владелец",
  "bank.ux.ownerMissing": "Организация не назначена",
  "bank.ux.savedRefreshError": "Изменение сохранено, но список счетов не удалось обновить. Перезагрузите страницу, чтобы увидеть актуальный статус.",
  "bank.ux.title": "Payables",
  "bank.ux.subtitle": "Подготовьте список платежей и управляйте банками. Подписание — в вашем банке.",
  "bank.ux.business": "Бизнес",
  "bank.ux.organization": "Организация плательщика",
  "bank.ux.selectedOrganization": "Выбранная организация",
  "bank.ux.banks": "Мои банки",
  "bank.ux.prepare": "Подготовить список платежей",
  "bank.ux.saved": "Сохранённые списки",
  "bank.ux.more": "Другие действия",
  "bank.ux.settings": "Настройки банка",
  "bank.ux.accounts": "Счета организации",
  "bank.ux.supplierAccounts": "Подтверждение счетов поставщиков",
  "bank.ux.access": "Кто может готовить платежи",
  "bank.ux.history": "История действий",
  "bank.ux.support": "Подробности для поддержки",
  "bank.ux.connect": "Подключить банк",
  "bank.ux.empty": "Подключите банк, чтобы проверить доступ к счетам вашей организации.",
  "bank.ux.reading": "Доступ к счетам подтверждён",
  "bank.ux.readOnly": "Доступ к счетам проверен. Создание черновиков платежей в этом банке пока недоступно.",
  "bank.ux.draftSupport": "Подключение поддерживает банковские черновики. Доступные действия также зависят от ваших прав.",
  "bank.ux.test": "Тестовое подключение",
  "bank.ux.pending": "Продолжить настройку",
  "bank.ux.state.DRAFT": "Настройка не завершена",
  "bank.ux.state.VALIDATING": "Проверяем доступ",
  "bank.ux.state.ACTIVE": "Доступ проверен",
  "bank.ux.state.SUSPENDED": "Приостановлено",
  "bank.ux.state.ERROR": "Требуется действие",
  "bank.ux.state.DRAINING": "Завершается после текущих операций",
  "bank.ux.state.RETIRED": "Отключено",
  "bank.ux.checked": "Последняя проверка: {date}",
  "bank.ux.notChecked": "Доступ ещё не проверен",
  "bank.ux.setupTitle": "Подключение банка",
  "bank.ux.step": "Шаг {current} из {total}",
  "bank.ux.credentialsHelp": "Введите данные доступа, выданные банком. Они передаются защищённо и очищаются после сохранения.",
  "bank.ux.where": "Где найти эти данные?",
  "bank.ux.whereHint": "Используйте данные доступа от BluOr после регистрации публичного ключа. Если Client ID или Client Secret не выданы, запросите их у банка.",
  "bank.ux.registration": "В интернет-банке BluOr откройте Settings → Key Management → Add Files. Загрузите скачанный публичный ключ, отметьте его и нажмите Send. Затем вернитесь сюда.",
  "bank.ux.computer": "Можно продолжить на компьютере: войдите в ту же организацию и откройте «Мои банки». Прогресс сохранён, пароли не переносятся.",
  "bank.ux.rotate": "Обновить данные доступа",
  "bank.ux.disconnect": "Отключить банк",
  "bank.ux.accountHelp": "Если счёт не найден, добавьте или активируйте IBAN организации в «Настройки банка → Счета организации», затем повторите проверку.",
  "bank.ux.self": "Я",
  "bank.ux.advanced": "Другие получатели доступа",
  "bank.ux.authorityHint": "Предоставление доступа — отдельное действие. Подключение банка не выдаёт права подготовки платежей.",
  "merchant.ap.debtorAccountIdentifier": "IBAN организации",
  "merchant.ap.subjectType": "Предоставить доступ",
  "merchant.ap.createAuthority": "Разрешить подготовку платежей",
  "merchant.ap.connectionScope": "Банк для этого доступа",
  "merchant.ap.anyConnection": "Все доступные подключения",
  "bank.wizard.payer": "Организация плательщика",
  "bank.wizard.generateKey": "Создать ключ подключения",
  "bank.wizard.keyHint": "Создайте ключ подключения. В банк передаётся только публичная часть.",
  "bank.wizard.brokerUnavailable": "Настройка подключения временно недоступна. Прогресс сохранён; обратитесь к администратору платформы.",
  "bank.wizard.step.COMPLETE": "Подтвердите подключение",
  "bank.wizard.step.PUBLIC_KEY": "Скачайте ключ для банка",
  "bank.wizard.step.KEY": "Создайте ключ подключения",
  "bank.wizard.step.REGISTRATION": "Зарегистрируйте ключ в банке",
  "bank.ux.account.SUPERSEDED": "Заменён новой версией счёта",
  "bank.ux.account.CANDIDATE": "Ожидает активации",
  "bank.ux.account.ACTIVE": "Счёт доступен",
  "bank.ux.account.ARCHIVED": "В архиве",
  "bank.ux.account.REJECTED": "Требует исправления",
  "bank.ux.searchRecipient": "Поиск по имени",
  "bank.ux.user": "Сотруднику",
  "bank.ux.party": "Организации",
  "bank.ux.businessScope": "Бизнесов в области доступа: {count}",
  "bank.ux.accessActive": "Доступ предоставлен",
  "bank.ux.accessEnded": "Доступ завершён",
  "merchant.ap.payment.title": "Подготовить список платежей",
  "merchant.ap.payment.hint": "Выберите счета поставщиков, проверьте список и сохраните его. Создание черновиков в банке — отдельный шаг.",
  "merchant.ap.loading": "Загрузка…",
  "bank.ux.expires": "Список действителен до {date}",
  "bank.ux.activity": "Изменение настроек банка",
  "bank.ux.activityAccess": "Изменение доступа к подготовке платежей",
  "bank.ux.activityKey": "Скачивание ключа подключения",
  "bank.ux.employee": "Сотрудник",
  "bank.ux.system": "Система",
  "bank.ux.prepareShort": "Новый список",
  "merchant.ap.payment.review": "Проверить список",
  "merchant.ap.verifiedCapabilities": "Возможности банка",
  "bank.ux.unavailable": "Подключение или счёт требует внимания. Проверьте настройки банка.",
  "payments.workspace.title": "Платежи поставщикам",
  "payments.workspace.recipient": "Получатель",
  "payments.workspace.status": "Состояние платежа",
  "payments.workspace.group": "Группировать по получателю",
  "payments.workspace.bankDraftHint": "Направлен в банк — черновик доступен для подписания. Оплата завершена только после подтверждения.",
  "payments.workspace.invoices": "Накладные",
  "payments.workspace.details": "Накладные и назначение платежа",
  "payments.workspace.review": "Открыть проверку накладной",
  "payments.workspace.open": "Открыть платёж",
  "payments.workspace.closePreparation": "Закрыть подготовку",
  "payments.workspace.prepare": "Подготовить платежи",
  "payments.workspace.incoming": "Входящие накладные в Goods",
  "payments.workspace.sourceHint": "Платежи формируются из проверенных и учтённых накладных в Goods. Перед подготовкой банковского черновика проверьте сумму и получателя.",
  "payments.state.REVIEW": "Требует проверки",
  "payments.state.READY": "Готов к отправке",
  "payments.state.PREPARING": "Подготавливается",
  "payments.state.BANK_DRAFT": "Направлен в банк · ожидает подписи",
  "payments.state.PROCESSING": "Обрабатывается банком",
  "payments.state.PAID": "Оплачен",
  "payments.state.PARTIAL": "Частично оплачен",
  "payments.state.ATTENTION": "Нужно уточнить",
  "payments.state.CANCELLED": "Отменён",
  "payments.source.awaitingAccounting": "Ожидает учёта в Goods",
  "payments.source.pending": "Ожидает записи к оплате",
  "payments.source.beforeEnablement": "Учтено до включения учёта платежей",
  "payments.source.unavailable": "Состояние платежа недоступно",
  "payments.source.open": "Открыть платёж",
  "payments.default.label": "По умолчанию для платежей",
  "payments.default.set": "Сделать основным",
  "payments.default.saved": "Основной счёт сохранён. Счета в существующих черновиках не изменены.",
  "payments.workspace.preparationHint": "Выберите накладные одного получателя, чтобы объединить их в платёж. Перед передачей черновиков в банк проверьте счёт, общую сумму и назначение.",
  "payments.workspace.sourceFilter": "Платежи по выбранной накладной",
  "payments.workspace.clearSource": "Показать все платежи",
  "payments.state.CLOSED": "Задолженность закрыта",
  "payments.state.PARTIALLY_CLOSED": "Задолженность частично закрыта",
  "payments.state.CREDIT": "Кредит поставщика для зачёта",
  "payables.title": "Payables",
  "payables.sections": "Рабочий список платежей",
  "payables.section.DUE": "К оплате",
  "payables.section.WORKING": "В работе",
  "payables.section.COMPLETE": "Завершено",
  "payables.section.ALL": "Все",
  "payables.search": "Поиск по получателю",
  "payables.tools": "Другие действия",
  "payables.back": "К платежам",
  "payables.visibleInvoices": "Накладных показано: {count}",
  "payables.selectInvoice": "Выбрать {invoices}",
  "payables.selected": "Выбрано: {count}",
  "payables.negativeSelection": "Выберите накладные для зачёта возврата.",
  "payables.prepare": "Подготовить платежи",
  "payables.retry": "Повторить",
  "payables.reviewInvoice": "Проверить накладную",
  "payables.checkResult": "Проверить результат",
  "payables.history": "Посмотреть историю",
  "payables.resolve": "Посмотреть детали",
  "payables.continue": "Продолжить",
  "payables.lastCheck": "Последнее обновление",
  "payables.supportCode": "Код для поддержки",
  "payables.partPaid": "Оплачено {paid} · осталось {remaining}",
  "payables.partOffset": "Погашено {paid} · осталось {remaining}",
  "payables.operationUncertain": "Часть результатов в этом списке нужно уточнить. Проверьте список перед повторной отправкой.",
  "payables.uncertain": "Результат не подтверждён. Проверьте его перед повторной отправкой.",
  "payables.emptyFiltered": "Подходящих накладных или платежей нет.",
  "payables.empty.DUE": "Нет накладных к оплате.",
  "payables.empty.WORKING": "Нет платежей в работе.",
  "payables.empty.COMPLETE": "Нет завершённых платежей.",
  "payables.empty.ALL": "Накладных и платежей пока нет.",
  "payables.state.REVIEW": "Нужно проверить",
  "payables.state.READY": "Можно оплатить",
  "payables.state.PREPARING": "Подготовлен",
  "payables.state.BANK_DRAFT": "Подписать в банке",
  "payables.state.PROCESSING": "Обрабатывается",
  "payables.state.PAID": "Оплачен",
  "payables.state.PARTIAL": "Частично оплачен",
  "payables.state.ATTENTION": "Нужно уточнить",
  "payables.state.CANCELLED": "Отменён",
  "payables.state.CLOSED": "Задолженность погашена",
  "payables.state.PARTIALLY_CLOSED": "Частично погашена",
  "payables.state.CREDIT": "Возврат для зачёта",
  "payables.issue.NOT_CREATED": "Черновик не создан",
  "payables.issueBody.NOT_CREATED": "Откройте детали платежа, устраните причину и повторите подготовку.",
  "payables.issue.PAYABLE_REVIEW": "Нужно проверить накладную",
  "payables.issue.EXPIRED": "Срок подготовки истёк",
  "payables.issue.BANK_REJECTED": "Банк отклонил платёж",
  "payables.issue.RESULT_UNCONFIRMED": "Нужно уточнить",
  "payables.issue.TIME_BUDGET": "Подготовка приостановлена",
  "payables.issue.STATUS_UNAVAILABLE": "Нужно уточнить",
  "payables.issueBody.PAYABLE_REVIEW": "Проверьте реквизиты накладной.",
  "payables.issueBody.EXPIRED": "Эта подготовка доступна только для просмотра. Для новой выберите доступные сейчас счета на экране «К оплате».",
  "payables.issueBody.BANK_REJECTED": "Проверьте результат банка и реквизиты платежа.",
  "payables.issueBody.TIME_BUDGET": "Созданные черновики сохранены. Продолжите подготовку остальных накладных.",
  "payables.routeHistory": "История подготовок",
  "payables.historyReadOnly": "Прошлые подготовки доступны только для просмотра. Новую подготовку начинайте только из доступных сейчас счетов.",
  "payables.preparation": "Подготовка платежа",
  "payables.continuePreparation": "Продолжить эту подготовку",
  "payables.empty.ARCHIVE": "Нет прошлых подготовок или отменённых платежей.",
  "payables.issue.SUPERSEDED": "Подготовку заменило новое состояние счёта",
  "payables.issueBody.SHARED_PREPARATION": "Этот счёт уже включён в подготовку нескольких мерчантов. Продолжить её может финансовый оператор с доступом ко всем включённым мерчантам. Здесь показан только счёт текущего мерчанта.",
};
